import Vue from 'vue';
import App from './App.vue';

//import store from "./store/index.js";
import router from "./router";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import $ from 'jquery';
import "@progress/kendo-ui";
import "@babel/polyfill";
import "@progress/kendo-theme-bootstrap/dist/all.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import { GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper'
import { ButtonsInstaller } from '@progress/kendo-buttons-vue-wrapper'
import { DropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper';
import { DateinputsInstaller } from '@progress/kendo-dateinputs-vue-wrapper';
import { InputsInstaller } from '@progress/kendo-inputs-vue-wrapper'
import VeeValidate from "vee-validate";
import VueSweetalert2 from 'vue-sweetalert2';
import VueProgressBar from 'vue-progressbar';
//import axiosInstance from './services/customAxios.js';
import http from '@/plugins/http.js';
import deepGroupBy from './services/groupByUtil';
import JSZip from 'jszip';
import linq from "linq";
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import moment from "moment";
import { AuthHelper, CreateAuthHelper } from '@/services/authUtils';
import { appendFile } from 'fs';
import { createLogger } from 'vuex'
import VueClipboard from 'vue-clipboard2';
import storePlugin from '@/plugins/storePlugin';
import { resolve } from 'path';

if(process.env.NODE_ENV != "local" && process.env.NODE_ENV != "dev")
  console.log = function(message){};

window.$ = window.jQuery = $;
window.JSZip = JSZip;
window.linq = linq;

Vue.config.productionTip = false

Vue.use(GridInstaller);
Vue.use(VeeValidate);
Vue.use(InputsInstaller);
Vue.use(DataSourceInstaller);
Vue.use(DateinputsInstaller);
Vue.use(ButtonsInstaller);
Vue.use(DropdownsInstaller);
Vue.use(VueSweetalert2);
Vue.use(Loading);
Vue.use(storePlugin, { someProp: 'blah' });
Vue.use(http);
Vue.use(VueClipboard);
Vue.use(VueProgressBar, {
  color: 'rgb(28, 203, 28)',
  failedColor: 'red',
  thickness: '5px',
  height: '2px',
  transition: {
    termination: 5000
  },
})
Vue.filter('formatDate', function (value) {
  if (value) {
    let date = new Date(value);
    return moment(String(date.toISOString())).format('MMMM DD, YYYY')
  }
});
// Takes decimal value and it round off with thousand separator(,)
Vue.filter('formatDecical', function (value) {
  if (value === 0) {
    return "0";
  } else if (value === "-" || value === "" || value === "null") {
    return "-";
  } else if(value === "N/A") {
    return "N/A";
  } else if (value) {
    return parseFloat(parseFloat(value).toFixed()).toLocaleString("en")
  }
});


Vue.prototype.$setUser = function (value) {
  $user = value;
}
Vue.prototype.$getUser = function () {
  return $user;
}
Vue.prototype.$user = {};

Vue.config.devtools = true;
// window.setInterval(function () {
//   //console.log("Checking for Token Expiration")
//   const resource = process.env.VUE_APP_server_applicationId;
//   AuthenticationContext.acquireToken(resource, (err, token) => {
//     if (err) {
//       //console.log("Error is ",err)
//     } else {
//       // console.log("Token is ",token)
//     }
//   })
// }, 300000)



//.default.configure(process.env.VUE_APP_CLIENT_ID);

const app = new Vue({
  router,
  render: h => h(App)
});
window.vm = app;



let ahelp = CreateAuthHelper(app.$store, process.env.VUE_APP_CLIENT_ID);
ahelp.ConfigureMsal(process.env.VUE_APP_CLIENT_ID);
ahelp.$app = app;
app.$eumAuth = ahelp;


//Vue.prototype.$customAxios = axiosInstance;

// customAxios().then(function(result){
//   console.log('axios result',result);
//   return result;
// });
//let axiosInst2 = Promise.resolve(axiosInst);
//app.$axios = axiosInst;
app.$mount("#app");



$(document).ready(function () {
  // window.App = app;
  //   this.$authHelper = this.$authHelper.configure(process.env.VUE_APP_CLIENT_ID);
  //  console.log(`authHelper=`,this.$authHelper);
})

